import React, { ReactNode, useContext, useEffect } from 'react'
import Divider from '../Divider'
import { ListItem, ListItemIcon, ListItemText, ListItemProps } from '../List'
import { MenuContext } from './Menu'

export interface MenuItemProps extends ListItemProps<'li'> {
  focused?: boolean
  /**
   * if true, the click on the MenuItem will not close the Menu
   * @default false
   *
   */
  disableCloseOnClick?: boolean
  /** Icon component */
  icon?: ReactNode
}

// TODO: not sure tabIndex=0 is a good choice for all items...
export const MenuItem = ({
  children,
  focused,
  icon,
  onClick,
  selected,
  disableCloseOnClick = false,
  ...rest
}: MenuItemProps) => {
  let ref = React.createRef<HTMLLIElement>()
  const { dispatch } = useContext(MenuContext)

  useEffect(() => {
    if (focused && ref.current) {
      ref.current.focus({ preventScroll: true })
    }
  }, [ref, focused])

  const onClicked = (e: any) => {
    onClick?.(e)
    if (!disableCloseOnClick) dispatch({ type: 'close' })
  }

  return (
    <ListItem
      ref={ref}
      tabIndex={0}
      selected={selected}
      role='menuitem'
      onKeyDown={(e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          onClicked(e)
        }
      }}
      onClick={onClicked}
      {...rest}
    >
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      <ListItemText>{children}</ListItemText>
    </ListItem>
  )
}

export const MenuDivider = () => <Divider dense />

export default MenuItem
